import React from 'react';
import { Result } from 'antd';
import { useHistory } from 'react-router-dom';

import { Page } from './../../components/Layouts';
import { PrimaryButton } from './../../components/Buttons';

const UserNotFound = () => {
  const history = useHistory();

  return (
    <Page>
      <Result
        status="404"
        title="User Not Found"
        subTitle="Sorry, we can't find you! Please contact your system administrator and ask them to add you as a User."
        extra={<PrimaryButton onClick={() => history.push('/')}>Back Home</PrimaryButton>}
      />
    </Page>
  );
};

export default UserNotFound;
